import { NextRequest, NextResponse } from "next/server";

import { COOKIES } from "constants/enum";
import { isString } from "utils/typeguards/isString";

import { getCookieExpires } from "./getCookieExpires";

export const getGeoDataByIP = (req: NextRequest, resp: NextResponse) => {
    const timezone = req.headers.get("X-Geoip2-Time-Zone");

    const latFromCookies = req.cookies.get(COOKIES.GEO_LATITUDE)?.value;
    const longFromCookies = req.cookies.get(COOKIES.GEO_LONGITUDE)?.value;

    const expires = getCookieExpires();

    if (latFromCookies && longFromCookies && timezone) {
        return {
            latitude: latFromCookies,
            longitude: longFromCookies,
            timezone,
        };
    }

    const latitude = req.headers.get("X-Geoip2-Latitude");
    const longitude = req.headers.get("X-Geoip2-Longitude");

    if (!isString(latitude) || !isString(longitude)) return null;

    const isAnalyticsAccepted =
        req.cookies.get(COOKIES.IS_ANALYSIS_COOKIE_ACTIVE)?.value === "1";

    if (isAnalyticsAccepted) {
        resp.cookies.set(COOKIES.GEO_LATITUDE, latitude, { expires });
        resp.cookies.set(COOKIES.GEO_LONGITUDE, longitude, { expires });
        if (timezone)
            resp.cookies.set(COOKIES.GEO_TIMEZONE, timezone, { expires });
    }

    return { latitude, longitude };
};
